import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="payment-cancel">
      <div className="brut-card p-10">
        <XCircle className="w-16 h-16 mx-auto text-tangerine mb-4" />
        <h1 className="font-display font-bold text-4xl">Payment cancelled</h1>
        <p className="text-ink/70 mt-3 text-lg">No worries — your order is saved. You can complete payment whenever you're ready.</p>
        <Link to="/order" className="brut-btn bg-bubble text-white mt-8 inline-flex">Back to order</Link>
      </div>
    </div>
  );
}
